define(
	'BTM.SearchBoxVisibility.SearchBoxVisibility', [
		'Backbone', 'SC.Configuration', 'Header.View', 'SiteSearch.View', 'Header.Menu.View', 'underscore', 'jQuery'
	],
	function (
		Backbone, Configuration, HeaderView, SiteSearchView, HeaderMenuView, _, jQuery
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var searchBoxVisibilityEnabled = Configuration.get('searchBoxVisibility.enabled');
				if (!searchBoxVisibilityEnabled) {
					return;
				}
				HeaderView.prototype.getContext = _.wrap(HeaderView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					context.alwaysShowSiteSearch = true;
					return context;
				});
				HeaderMenuView.prototype.getContext = _.wrap(HeaderMenuView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					context.alwaysShowSiteSearch = true;
					return context;
				});
				_.extend(HeaderView.prototype, {
					showSiteSearch: function (ev) {
						// (*_0) No action here
					},
					hideSiteSearch: function () {
						// (*_0) No action here
					}
				});
				_.extend(SiteSearchView.prototype, {
					showSiteSearch: function (dontFocus) {
						// (*_0) No action here
					}
				});
			}
		};
	});
